import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "todo-item__status" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2" })
], -1)
const _hoisted_2 = { class: "todo-item__text" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash3" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["todo-item", { 'todo-item--done': _ctx.item.status }]),
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleItem && _ctx.toggleItem(...args)))
  }, [
    _hoisted_1,
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.item.text), 1),
    _createElementVNode("button", {
      class: "todo-item__remove-button",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeItem && _ctx.removeItem(...args)), ["stop"]))
    }, _hoisted_4)
  ], 2))
}